import React, { useEffect, useRef } from "react";
import { useWebChatCore } from "../../../../cores/webChat";
import { PanelWembii } from "../../PanelWembii";
import { useMeCore } from "../../../../cores/me";
import { useSocketCore } from "../../../../cores/socket";
import MessageRow from "../MessageRow";
import { WebMessage } from "../../../../cores/webChat/interfaces/api/get-messages";
import SubmitInput from "../SubmitInput";

export default function WebChatForm() {
  const { company, user } = useMeCore();
  const { selected, messages, getMessages } = useWebChatCore();
  const { sendMessageToChannel } = useSocketCore();
  const ref = useRef<any>(null);
  
  useEffect(() => {
    getMessages(company?.id!, selected?.id!);
  }, [getMessages, selected, company]);

  useEffect(() => {
    if (ref !== null) {
      ref.current?.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }
  }, [messages]);

  const onSubmit = (text: string) => {     
    const message = {
      content: text,
      type: "TEXT",
      conversationId: selected?.id,
      userId: user?.id!,
    };
    sendMessageToChannel(selected?.room!, message);
  };

  const itsMe = (message: WebMessage) => !!message.from.id;

  return (
    <PanelWembii shadow className="p-3 mb-3">
      <div
        className="overflow-auto hide-scrollbar"
        style={{
          height: "calc(100vh - 420px)"
        }}
      >
        {messages.map((message) => (
          <MessageRow key={message.id} message={message} itsMe={itsMe(message)} />
        ))}
        <div ref={ref} />
      </div>
      <SubmitInput onSubmit={onSubmit} />
    </PanelWembii>
  );
}
